import React from 'react';
import {Result,Button} from 'antd';
import { useTranslation } from 'react-i18next';

function ErrorPage(props){
	const {t} = useTranslation();
	return (
		<>
			<Result
				status="500"
				// title={props.error}
				subTitle={t("Sorry, Something went wrong.")}
				extra={
						<Button type="primary">
							<a href="/ade-platform/web/public">{t("Back Home")}</a>
						</Button>
				}
  		/>
		</>
	);
}

export default ErrorPage;
